// VA certification status of a roster profile (`attributes.submittedToVa`), in the
// order compliance works through it (DEV-735). Mirrors mgmt-api src/utils/va-submission.js.
export const submittedToVaOptions = [
  { label: 'N/A', value: 'na' },
  { label: 'No', value: 'no' },
  { label: 'Pre-Enroll - Full', value: 'pre_enroll_full' },
  { label: 'Pre-Enroll - Pt 1', value: 'pre_enroll_pt1' },
  { label: 'Attendance - Full', value: 'attendance_full' },
  { label: 'Attendance - Pt 1', value: 'attendance_pt1' },
  { label: 'Pre-Enroll - Pt 2', value: 'pre_enroll_pt2' },
  { label: 'Attendance - Pt 2', value: 'attendance_pt2' },
  { label: 'Term/WD', value: 'term_wd' },
  { label: 'Grad/Complete', value: 'grad_complete' },
  { label: 'Employed', value: 'employed' },
  { label: 'Employed 180d', value: 'employed_180d' },
];

export const resolveSubmittedToVaLabel = (value) => {
  const option = submittedToVaOptions.find((entry) => entry.value === value);
  return option ? option.label : value;
};

export const resolveSubmittedToVaVariant = (value) => {
  if (value === 'no') return 'danger';
  if (value === 'na' || !value) return 'secondary';
  if (value === 'term_wd') return 'warning';
  if (['grad_complete', 'employed', 'employed_180d'].includes(value)) return 'success';
  return 'info'; // pre-enroll and attendance stages: in progress
};
